//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { AuthorizedApiBase } from "./authorized-api-base";

export class UserAssignmentServiceClient extends AuthorizedApiBase {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? "";
    //this._http = http;
  }

  orchestrator_Orchestrator(
    userAssignmentRequestMessage: UserAssignmentMessage,
    signal?: AbortSignal
  ): Promise<boolean> {
    let url_ = this.baseUrl + "/api/v1/Orchestrator/Orchestrator";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(userAssignmentRequestMessage);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processOrchestrator_Orchestrator(_response);
      });
  }

  protected processOrchestrator_Orchestrator(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  postToUserAssignment(endpoint: string, payload: any, signal?: AbortSignal): Promise<boolean> {
    let url_ = `${this.baseUrl}${endpoint}`;
    //let url_ = 'https://localhost:7227' + endpoint;
    url_ = url_.replace(/[?&]$/, "");
    console.log(this.baseUrl);
    const content_ = JSON.stringify(payload);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPopulateAssignment_SyncAssignmentFromRT(_response);
      });
  }

  protected processPostToUserAssignment(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  populateAssignment_SyncCEMAssignment(signal?: AbortSignal): Promise<boolean> {
    let url_ = this.baseUrl + "/api/v1/PopulateAssignment/SyncCEMAssignment";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPopulateAssignment_SyncCEMAssignment(_response);
      });
  }

  protected processPopulateAssignment_SyncCEMAssignment(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  populateAssignment_SyncAssignmentByClientId(clientId: number, signal?: AbortSignal): Promise<boolean> {
    let url_ = this.baseUrl + "/api/v1/PopulateAssignment/SyncAssignmentByClientId/{clientId}";
    if (clientId === undefined || clientId === null) throw new Error("The parameter 'clientId' must be defined.");
    url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPopulateAssignment_SyncAssignmentByClientId(_response);
      });
  }

  protected processPopulateAssignment_SyncAssignmentByClientId(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  populateAssignment_SyncAssignmentFromRT(
    rtMessage: CemUserAssignmentRTMessage,
    signal?: AbortSignal
  ): Promise<boolean> {
    let url_ = this.baseUrl + "/api/v1/PopulateAssignment/SyncAssignmentFromRT";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(rtMessage);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPopulateAssignment_SyncAssignmentFromRT(_response);
      });
  }

  protected processPopulateAssignment_SyncAssignmentFromRT(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  populateAssignment_SyncRoles(applicationId: string | null | undefined, signal?: AbortSignal): Promise<boolean> {
    let url_ = this.baseUrl + "/api/v1/PopulateAssignment/SyncRoles?";
    if (applicationId !== undefined && applicationId !== null)
      url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPopulateAssignment_SyncRoles(_response);
      });
  }

  protected processPopulateAssignment_SyncRoles(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  populateUserProfile_UpdateUserProfileIdm(signal?: AbortSignal): Promise<boolean> {
    let url_ = this.baseUrl + "/api/v1/PopulateUserProfile/UpdateUserProfileIdm";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPopulateUserProfile_UpdateUserProfileIdm(_response);
      });
  }

  protected processPopulateUserProfile_UpdateUserProfileIdm(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  populateUserProfile_UpdateUserProfileHq(signal?: AbortSignal): Promise<boolean> {
    let url_ = this.baseUrl + "/api/v1/PopulateUserProfile/UpdateUserProfileHq";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPopulateUserProfile_UpdateUserProfileHq(_response);
      });
  }

  protected processPopulateUserProfile_UpdateUserProfileHq(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  userAssignment_WebhookInitiate(request: WebhookRequestMessage, signal?: AbortSignal): Promise<boolean> {
    let url_ = this.baseUrl + "/api/v1/UserAssignment/WebhookInitiate";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUserAssignment_WebhookInitiate(_response);
      });
  }

  protected processUserAssignment_WebhookInitiate(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  userAssignment_UserAssignTpacTrigger(
    assignTpac: UserAssignTpac | undefined,
    messages: TpacRequestBasicMessage[],
    signal?: AbortSignal
  ): Promise<boolean> {
    let url_ = this.baseUrl + "/api/v1/UserAssignment/UserAssignTpacTrigger?";
    if (assignTpac === null) throw new Error("The parameter 'assignTpac' cannot be null.");
    else if (assignTpac !== undefined) url_ += "assignTpac=" + encodeURIComponent("" + assignTpac) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(messages);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUserAssignment_UserAssignTpacTrigger(_response);
      });
  }

  protected processUserAssignment_UserAssignTpacTrigger(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  userAssignment_TpacInitiate(requestMessage: TpacRequestMessage, signal?: AbortSignal): Promise<boolean> {
    let url_ = this.baseUrl + "/api/v1/UserAssignment/TpacInitiate";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(requestMessage);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUserAssignment_TpacInitiate(_response);
      });
  }

  protected processUserAssignment_TpacInitiate(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  userAssignment_ProcessConsentVerification(
    requestMessage: TpacRequestMessage,
    signal?: AbortSignal
  ): Promise<boolean> {
    let url_ = this.baseUrl + "/api/v1/UserAssignment/ProcessConsentVerification";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(requestMessage);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUserAssignment_ProcessConsentVerification(_response);
      });
  }

  protected processUserAssignment_ProcessConsentVerification(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  userAssignment_DirectRoleAssignInitiate(request: AssignRoleRequestMessage, signal?: AbortSignal): Promise<boolean> {
    let url_ = this.baseUrl + "/api/v1/UserAssignment/DirectRoleAssignInitiate";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUserAssignment_DirectRoleAssignInitiate(_response);
      });
  }

  protected processUserAssignment_DirectRoleAssignInitiate(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  userAssignment_UserAssignmentHistory(
    siteId: number | undefined,
    searchTerm?: string | null | undefined,
    userId?: string | null | undefined,
    offset?: number | undefined,
    limit?: number | undefined,
    signal?: AbortSignal
  ): Promise<UserAssignmentHistoryResponse> {
    let url_ = this.baseUrl + "/api/v1/UserAssignment/UserAssignmentHistory?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (userId != null) url_ += "userId=" + encodeURIComponent(userId) + "&";
    if (searchTerm != null) url_ += "searchTerm=" + encodeURIComponent(searchTerm) + "&";
    if (offset === null) throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined) url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null) throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined) url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUserAssignment_UserAssignmentHistory(_response);
      });
  }

  protected processUserAssignment_UserAssignmentHistory(response: Response): Promise<UserAssignmentHistoryResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<UserAssignmentHistoryResponse>(null as any);
  }

  userAssignment_SendUserEmail(request: UserEmailRequestDto, signal?: AbortSignal): Promise<boolean> {
    let url_ = this.baseUrl + "/api/v1/UserAssignment/SendUserEmail";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUserAssignment_SendUserEmail(_response);
      });
  }

  protected processUserAssignment_SendUserEmail(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  userAssignment_TessRoleAssignInitiate(request: TpacRequestMessage, signal?: AbortSignal): Promise<boolean> {
    let url_ = this.baseUrl + "/api/v1/UserAssignment/TessRoleAssignInitiate";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUserAssignment_TessRoleAssignInitiate(_response);
      });
  }

  protected processUserAssignment_TessRoleAssignInitiate(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  userAssignment_L2SupportUsers(siteId: number | undefined, signal?: AbortSignal): Promise<L2SupportUsersResponse> {
    let url_ = this.baseUrl + "/api/v1/UserAssignment/L2SupportUsers?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUserAssignment_L2SupportUsers(_response);
      });
  }

  protected processUserAssignment_L2SupportUsers(response: Response): Promise<L2SupportUsersResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<L2SupportUsersResponse>(null as any);
  }

  userAssignment_GetUserAssignmentList(
    siteId: number | null | undefined,
    userEmail: string | null | undefined,
    roleName: string | null | undefined,
    groupName: string | null | undefined,
    signal?: AbortSignal
  ): Promise<UserAssignmentListResponseDto> {
    let url_ = this.baseUrl + "/api/v1/UserAssignment/GetUserAssignmentList?";
    if (siteId !== undefined && siteId !== null) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (userEmail !== undefined && userEmail !== null) url_ += "userEmail=" + encodeURIComponent("" + userEmail) + "&";
    if (roleName !== undefined && roleName !== null) url_ += "roleName=" + encodeURIComponent("" + roleName) + "&";
    if (groupName !== undefined && groupName !== null) url_ += "groupName=" + encodeURIComponent("" + groupName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {     
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUserAssignment_GetUserAssignmentList(_response);
      });
  }

  protected processUserAssignment_GetUserAssignmentList(response: Response): Promise<UserAssignmentListResponseDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as UserAssignmentListResponseDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<UserAssignmentListResponseDto>(null as any);
  }

  userAssignment_GetRoles(applicationId: string | null | undefined, signal?: AbortSignal): Promise<RoleListResponseDto> {
    let url_ = this.baseUrl + "/api/v1/UserAssignment/GetRoles?";
    if (applicationId !== undefined && applicationId !== null)
      url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUserAssignment_GetRoles(_response);
      });
  }

  protected processUserAssignment_GetRoles(response: Response): Promise<RoleListResponseDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as RoleListResponseDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<RoleListResponseDto>(null as any);
  }
}

export interface ProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;
}

export interface WebhookRequestMessage {
  hqItemId?: number;
  hqSiteId?: number;
  hqiSheetId?: number;
  iSheetName?: string | undefined;
  mdmClientId?: number;
  appName?: string | undefined;
  initiatedBy?: string;
  userAssignmentStepName?: string;
  action?: UserAssignmentCEMAction | undefined;
  eventType?: ServiceBusEnum;
  correlationId?: string;
}

export interface UserAssignmentMessage extends WebhookRequestMessage {
  firstName?: string | undefined;
  lastName?: string | undefined;
  userEmail?: string | undefined;
  userCountryCode?: string | undefined;
  idmUserStatus?: string | undefined;
  userId?: string;
  tpUserId?: string;
  insightReportAccess?: string | undefined;
  orgId?: string | undefined;
  orgName?: string | undefined;
  isConsentReceived?: boolean | undefined;
  userAssignmentId?: number;
  cemAction?: UserAssignmentCEMAction;
  roleId?: string | undefined;
  userType?: UserAssignmentType;
}

export enum UserAssignmentAction {
  Add = 0,
  Remove = 1,
  ChangeRole = 2,
}

export enum UserAssignmentCEMAction {
  Add = 0,
  Remove = 1,
}

export enum UserAssignmentType {
  Internal = 0,
  ClientUser = 1,
  ThirdParty = 2,
  MemberFirm = 3,
}

export enum ServiceBusEnum {
  CREATE_EXTERNAL_USER = 115,
  CREATE_EXTERNAL_USER_THIRD_PARTY = 138,
  INTERNAL_USER_ASSIGNMENT = 142,
  MEMBER_FIRM = 161,
  USER_ASSIGNMENT_MICRO_SERVICE = 202,
}

export interface CemUserAssignmentRTMessage {
  action?: string | undefined;
  userId?: string | undefined;
  roleId?: string | undefined;
  connectId?: string | undefined;
  connectType?: string | undefined;
  applicationId?: string | undefined;
  userAssignmentStepName?: string | undefined;
}

export enum UserAssignTpac {
  TriggerUserAssign = 0,
  TriggerConsentVerification = 1,
  TriggerCheckStatus = 2,
  TessRoleAssignInitiate = 3,
}

export interface TpacRequestBasicMessage {
  hqSiteId?: number;
  appName?: string | undefined;
  iSheetType?: string | undefined;
  source?: string | undefined;
}

export interface TpacRequestMessage extends TpacRequestBasicMessage {
  initiatedBy?: string;
  userAssignmentStepName?: string;
  eventType?: ServiceBusEnum;
  correlationId?: string;
}

export interface AssignRoleRequestMessage {
  hqSiteId?: number;
  userEmail?: string | undefined;
  roleName?: string | undefined;
  action?: UserAssignmentCEMAction | undefined;
  appName?: string | undefined;
  initiatedBy?: string;
  userAssignmentStepName?: string | undefined;
  eventType?: ServiceBusEnum | undefined;
  correlationId?: string | undefined;
  Source?: string | undefined;
}

export interface UserAssignmentHistoryResponse {
  statusCode: number | undefined;
  message: string | undefined;
  data?: UserAssignmentHistoryDto | undefined;
}

export interface UserAssignmentHistoryDto {
  offset: number | undefined;
  limit: number | undefined;
  totalCount: number | undefined;
  userAssignmentHistory: UserAssignmentData[] | undefined;
}

export interface UserAssignmentData {
  userId: string;
  hqSiteId: number;
  username: string;
  roleId: string;
  roleName: string;
  userAssignmentId: number;
  latestActivity: string;
  latestActivityDate: string;
  entityName: string;
  isActive: boolean;
}

export interface UserEmailRequestDto {
  type?: string | undefined;
  siteId?: string | undefined;
  itemId?: string | undefined;
  initiatedBy?: string;
  correlationId?: string | undefined;
  eventType?: ServiceBusEnum;
}

export interface UserAssignmentListResponseDto {
  statusCode?: number;
  message?: string | undefined;
  data?: {
    data?: UserAssignmentListDto[];
    message?: string | undefined;
    isSuccess?: boolean;
  };
}

export interface UserAssignmentListDto {
  hqSiteId?: number | undefined;
  hqSiteName?: string | undefined;
  userId?: string | undefined;
  tpUserId?: string | undefined;
  userEmail?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  roleId?: string | undefined;
  roleName?: string | undefined;
  userGroups?: string | undefined;
  userAssignmentType?: string | undefined;
}

export interface RoleListResponseDto {
  statusCode?: number;
  message?: string | undefined;
  data?: {
    data?: RoleDto[];
    message?: string | undefined;
    isSuccess?: boolean;
  };
}

export interface RoleDto {
  id?: string | undefined;
  name?: string | undefined;
  displayName?: string | undefined;
}

export interface L2SupportUsersResponse {
  statusCode: number;
  message: string;
  data: string[];
}
export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}
